import {
  MAX_FIELD_SIZE,
  MAX_FIELD_TO_BBOX_RATIO,
  mergeFeatureCollection,
  MIN_FIELD_SIZE,
  SQUARE_METERS_PER_ACRE,
} from '@cibo/core'
import { area, bbox, bboxPolygon, FeatureCollection } from '@turf/turf'
import i18next from 'i18next'

export const featureAcreage = (features: FeatureCollection) => {
  const mergedFeatures = mergeFeatureCollection(features)
  const sqMeters = !!mergedFeatures ? area(mergedFeatures) : 0

  return sqMeters / SQUARE_METERS_PER_ACRE
}

export const fieldSizeValidation = (features: FeatureCollection) => {
  const mergedFeatures = mergeFeatureCollection(features)
  const sqMeters = !!mergedFeatures ? area(mergedFeatures) : 0
  const bbSqMeters = !!mergedFeatures ? area(bboxPolygon(bbox(mergedFeatures))) : 0

  const errorMessages = [] as string[]
  const errorCodes = [] as string[]
  if (sqMeters !== 0 && sqMeters < MIN_FIELD_SIZE) {
    errorMessages.push(
      i18next.t('@cibo/landmanager/fieldSizeValidation:tooSmall', {
        count: MIN_FIELD_SIZE / SQUARE_METERS_PER_ACRE,
      })
    )
    errorCodes.push('tooSmall')
  }
  if (sqMeters > 0 && bbSqMeters / sqMeters > MAX_FIELD_TO_BBOX_RATIO) {
    errorMessages.push(i18next.t('@cibo/landmanager/fieldSizeValidation:tooSparse'))
    errorCodes.push('tooSparse')
  }
  if (sqMeters > MAX_FIELD_SIZE) {
    errorMessages.push(
      i18next.t('@cibo/landmanager/fieldSizeValidation:tooBig', {
        max: MAX_FIELD_SIZE / SQUARE_METERS_PER_ACRE,
      })
    )
    errorCodes.push('tooBig')
  }

  return {
    acres: sqMeters / SQUARE_METERS_PER_ACRE,
    errorMessages,
    errorCodes,
  }
}
